module.exports = __webpack_public_path__ + "img/floor.9931214b.jpg";